/**
 * Room domain constants.
 *
 * There is a real Raeume row (id 423) that represents "Online". Its id is used
 * throughout the app as a sentinel: to relabel/exclude that room in pickers, to
 * default new seminars to online, and to drive "is this seminar online" logic.
 * Naming it here keeps the magic number in one place instead of ~9 files.
 */
export const ONLINE_RAUM_ID = 423;
